import { Else, If, Then } from 'react-if';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useAuth } from '@zep/auth';
import { logger } from '@zep/core-logger';
import { PlusIcon } from '@zep/icons';
import { Button, Stack } from '@zep/ui';
import { Colors } from '@zep/ui-tokens';
import { PostBillingCardCallBack } from '../../../../../services';
import { PaypleWidgetDefaultPayload, usePayple } from '../../hooks';
import { makeRedirectUrl } from '../../subscriptionUtil';
import { useSubscriptionPaymentContext } from '../hooks';
import S from './PaymentPaypleCardRegister.module.scss';
import { PaymentUserInfo, SubscriptionRegisterSection } from './PlanCheckoutPayment';
export const PaymentPaypleCardRegister = () => {
  const {
    showWidget: _showWidget
  } = usePayple();
  const {
    user
  } = useAuth();
  const router = useRouter();
  const {
    billingInfo,
    handleStep,
    selectedPlan,
    selectedMaxCcu,
    spaceHashId,
    subscriptionPeriod
  } = useSubscriptionPaymentContext();
  const showWidget = () => {
    logger.track('payment_subscription_payple_card_registration');
    _showWidget({
      ...PaypleWidgetDefaultPayload,
      type: 'subscription',
      // @ts-ignore
      playerEmail: user.snsId,
      spaceHashId,
      callbackUrl: PostBillingCardCallBack,
      failRedirectUrl: makeRedirectUrl(router, {
        isBillingRegister: false,
        plan: selectedPlan,
        maxCcu: selectedMaxCcu.toString(),
        subscriptionPeriod
      }),
      successRedirectUrl: makeRedirectUrl(router, {
        isBillingRegister: true,
        plan: selectedPlan,
        maxCcu: selectedMaxCcu.toString(),
        subscriptionPeriod
      })
    });
  };
  return <SubscriptionRegisterSection onHeaderButtonClick={() => handleStep(1)} data-sentry-element="SubscriptionRegisterSection" data-sentry-component="PaymentPaypleCardRegister" data-sentry-source-file="PaymentPaypleCardRegister.tsx">
      <If condition={!billingInfo || billingInfo.cardName === 'TEMP'} data-sentry-element="If" data-sentry-source-file="PaymentPaypleCardRegister.tsx">
        <Then data-sentry-element="Then" data-sentry-source-file="PaymentPaypleCardRegister.tsx">
          <AddCard showWidget={showWidget} data-sentry-element="AddCard" data-sentry-source-file="PaymentPaypleCardRegister.tsx" />
        </Then>
        <Else data-sentry-element="Else" data-sentry-source-file="PaymentPaypleCardRegister.tsx">
          <PaymentUserInfo onChangePaymentCard={showWidget} data-sentry-element="PaymentUserInfo" data-sentry-source-file="PaymentPaypleCardRegister.tsx" />
        </Else>
      </If>
    </SubscriptionRegisterSection>;
};
const AddCard = ({
  showWidget
}: {
  showWidget: (isUpdated: boolean) => void;
}) => {
  const {
    t
  } = useTranslation(['subscription']);
  return <Stack gap={12} data-sentry-element="Stack" data-sentry-component="AddCard" data-sentry-source-file="PaymentPaypleCardRegister.tsx">
      <Stack gap={4} data-sentry-element="Stack" data-sentry-source-file="PaymentPaypleCardRegister.tsx">
        <div className={S.add_card_title}>
          {t('subscription:payment.cardChange.title')}
        </div>
        <div className={S.add_card_content} dangerouslySetInnerHTML={{
        __html: t('subscription:paymentPayple.cardRegister.description')
      }} />
      </Stack>
      <div className={S.add_card_button_wrapper}>
        <Button variant="primary" size={'sm'} leftSlot={<PlusIcon fill={Colors.White} />} onClick={() => showWidget(false)} data-sentry-element="Button" data-sentry-source-file="PaymentPaypleCardRegister.tsx">
          {t('subscription:paymentPayple.cardRegister.buttonAdd')}
        </Button>
      </div>
    </Stack>;
};